if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal--visible');
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
  );

  const observeAll = () => {
    document.querySelectorAll('.scroll-reveal:not(.scroll-reveal--visible)').forEach((el) => {
      observer.observe(el);
    });
  };

  observeAll();
  document.addEventListener('shopify:section:load', observeAll);
}
